import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import LaunchIcon from "@material-ui/icons/Launch";

const useStyles = makeStyles({
  link: {
    textDecoration: "none",
    alignSelf: "flex-start",
  },
  icon: {
    width: "0.5em",
    paddingLeft: 2,
  },
  resize: {
    maxWidth: "50%",
    maxHeight: "50%",
  },
});

const FilePreview = ({ url }) => {
  const classes = useStyles();
  const renderPreview = () => {
    if (url !== "") {
      if (url.includes("audio")) {
        return (
          <audio src={url} controls>
            Your browser does not support the audio tag.
          </audio>
        );
      } else if (url.includes("video")) {
        return (
          <video src={url} width="75%" height="75%" controls>
            Your browser does not support the video tag.
          </video>
        );
      } else if (
        url.includes("pdf") ||
        url.includes("docx") ||
        url.includes("doc")
      ) {
        return (
          <iframe src={url} title="Uploaded file" width="100%" height="80%">
            This browser does not support PDFs.
          </iframe>
        );
      } else if (url.includes("image")) {
        return (
          <img
            src={url}
            alt={"image cant be loaded, open it at " + url}
            className={classes.resize}
          />
        );
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        alignItems: "center",
      }}
    >
      <a
        href={url}
        className={classes.link}
        target="_blank"
        rel="noopener noreferrer"
      >
        Click To Open In New Tab
        <LaunchIcon className={classes.icon} />
      </a>
      {renderPreview()}
    </div>
  );
};

export default FilePreview;
